<template>
  <div id="app">
    <template v-if="!loading">
      <RouterView class="page_container" />

      <!-- 底部标签栏 -->
      <van-tabbar v-show="show" v-model="active" :border="false" route fixed placeholder safe-area-inset-bottom>
        <van-tabbar-item v-for="(item, index) in tabbar" :key="index" :class="{ center: index == 2 }" :icon="item.icon"
          :to="item.path">
          {{ item.label }}
        </van-tabbar-item>
      </van-tabbar>

      <!-- 消息弹窗 -->
      <van-popup class="popup" v-model="showTabbar" round>
        <p class="popup_title">{{ msg.title }}</p>
        <p class="popup_content">{{ msg.content }}</p>
        <van-button class="close_btn" block @click="show = false">{{ $t('public.close') }}</van-button>
      </van-popup>
    </template>

    <div v-if="error" class="network_error">
      <van-empty image="network" :description="$t('public.networkError')" />
      <van-button class="retry_btn" round @click="onRefreshPage">{{ $t('public.retry') }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      tabbar: [ // tabbar 配置数据
        {
          label: this.$t('public.tabbar')[0],
          icon: "wap-home",
          path: '/home',
        },
        {
          label: this.$t('public.tabbar')[1],
          icon: "shop",
          path: '/commodity',
        },
        {
          label: this.$t('public.tabbar')[2],
          icon: "bag",
          path: '/grabOrder',
        },
        {
          label: this.$t('public.tabbar')[3],
          icon: "service",
          path: '/customerService',
        },
        {
          label: this.$t('public.tabbar')[4],
          icon: "manager",
          path: '/mine',
        },
      ],
      active: 0, // 当前索引
      showTabbar: false, // 是否显示 tabbar
      loading: true, // 加载中
      error: false, // 网络错误
      theme_color: '', // 主题色
      show: false, // 是否显示消息弹窗
      msg: {}, // 弹窗消息
    }
  },

  created() {
    this.getSystemConfig()
  },

  watch: {
    // 监听路由，判断是否显示 tabbar，以及判断要显示的索引
    '$route': {
      handler(newVal) {
        const { path, name } = newVal
        const index = this.tabbar.findIndex(item => item.path === path)

        document.title = this.$t(name).title || 'pomelo'
        this.show = index !== -1
        this.active = index
      },
      immediate: true,
    }
  },

  methods: {
    // 获取系统配置
    async getSystemConfig() {
      this.$toast.loading(this.$t('public.loadingText'))

      let res = await this.$http.getSystemConfig()
      console.log('获取系统配置', res);

      const { code, data, msg } = res || {}
      if (code !== 200 && code !== 402) {
        this.error = true
        return this.$toast.fail(msg)
      }

      this.$toast.clear()
      localStorage.setItem('systemConfig', JSON.stringify(data))
      this.loading = false
      this.theme_color = data.theme_color
      setInterval(this.getPopupNotification, 30000)
    },

    // 获取消息弹窗
    async getPopupNotification() {
      const token = localStorage.getItem('token')
      if (!token) return

      let res = await this.$http.getPopupNotification()
      console.log('获取消息弹窗', res);

      const { code, data } = res || {}
      if (code === 200 && data) {
        this.show = true
        this.msg = data
      }
    },

    // 刷新页面
    onRefreshPage() {
      location.reload()
    },
  }
}
</script>

<style lang="less" scoped>
#app {
  max-width: 860px;
  width: 100%;
  height: 100%;
  background: #ffffff;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  .page_container {
    width: 100%;
    height: 100%;
    padding-bottom: 80px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.popup {
  width: 80%;
  max-width: calc(860px * 0.8);
  padding: 40px;

  .popup_title {
    text-align: center;
    font-weight: 600;
    margin-bottom: 40px;
  }

  .popup_content {
    font-size: 28px;
    text-indent: 2em;
  }

  .close_btn {
    color: #ffffff;
    background: var(--theme-color);
    border: none;
    border-radius: 16px;
    margin-top: 60px;
  }
}

.network_error {
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .retry_btn {
    width: 320px;
    color: #ffffff;
    background: var(--theme-color);
    border: none;
  }
}

@keyframes gradientShapeAnimation1 {
  0% {
    -webkit-transform: translate(-30%, 40%) rotate(-20deg);
    transform: translate(-30%, 40%) rotate(-20deg)
  }

  25% {
    -webkit-transform: translate(0%, 20%) skew(-15deg, -15deg) rotate(80deg);
    transform: translate(0%, 20%) skew(-15deg, -15deg) rotate(80deg)
  }

  50% {
    -webkit-transform: translate(30%, -10%) rotate(180deg);
    transform: translate(30%, -10%) rotate(180deg)
  }

  75% {
    -webkit-transform: translate(-30%, 40%) skew(15deg, 15deg) rotate(240deg);
    transform: translate(-30%, 40%) skew(15deg, 15deg) rotate(240deg)
  }

  100% {
    -webkit-transform: translate(-30%, 40%) rotate(-20deg);
    transform: translate(-30%, 40%) rotate(-20deg)
  }
}

@keyframes gradientShapeAnimation2 {
  0% {
    -webkit-transform: translate(20%, -40%) rotate(-20deg);
    transform: translate(20%, -40%) rotate(-20deg)
  }

  20% {
    -webkit-transform: translate(0%, 0%) skew(-15deg, -15deg) rotate(80deg);
    transform: translate(0%, 0%) skew(-15deg, -15deg) rotate(80deg)
  }

  40% {
    -webkit-transform: translate(-40%, 50%) rotate(180deg);
    transform: translate(-40%, 50%) rotate(180deg)
  }

  60% {
    -webkit-transform: translate(-20%, -20%) skew(15deg, 15deg) rotate(80deg);
    transform: translate(-20%, -20%) skew(15deg, 15deg) rotate(80deg)
  }

  80% {
    -webkit-transform: translate(10%, -30%) rotate(180deg);
    transform: translate(10%, -30%) rotate(180deg)
  }

  100% {
    -webkit-transform: translate(20%, -40%) rotate(340deg);
    transform: translate(20%, -40%) rotate(340deg)
  }
}
</style>
